$(function(){
	$('.price-recount').priceRecount()
})
+function($){

	$.fn.priceRecount = function(){
		return this.each(function(){
			var t = $(this)
			var priceBox = $('.price-box', t)
			var priceText = $('.price-text', t)
			var defaultPrice = APP_PRICE
			var codeBox = $('input[name=code]', t)

			function setPriceText(discount, discountText){
				if(discount > 0) 
                    priceText.text(localizedTexts.dev.priceAfterDiscount + ' ' + discountText) 
				else priceText.text(localizedTexts.dev.priceWithoutDiscount)
			}

			$('input[name=code]', t).keypress(function(e){
				if(e.which == 13) {
					e.preventDefault()
					$('.check-code', t).click()
				}
			})

			$('.check-code', t).click(function(e){
				e.preventDefault()
				var code = codeBox.val()
				if(!code) {
			      	alert(localizedTexts.dev.noDiscountCode);
			      	return;
				}
			    $.post(baseUrl+'/check-code', {'code': code}, function(data) {
			      if (!data || !data.result) {
			        alert(localizedTexts.dev.connectionError2);
			        return; 
			      }

			      if (data.result.codeState == 'redeemed') {
			        alert(localizedTexts.dev.CodeAlreadyBeenUsed);
			        return;
			      }
			      
			      if (data.result.codeState == 'expired') {
			        alert(localizedTexts.dev.CodeExpired);
			        return;
			      }
			      
			      if (data.result.codeState == 'invalid') {
			        alert(localizedTexts.dev.CodeNotValid);
			        return;
			      }
			      
			      if (data.result.codeState == 'valid') {
			      	setPriceText(data.result.discount, data.result.discountText)
					priceBox.text(data.result.priceText)
					
			        if (data.result.discount == 100) {
			          $('input[type=submit]').val(localizedTexts.dev.continue);
			          $('#paymentNote').hide();
			        }

		        	$([document.documentElement, document.body]).animate({
			            scrollTop: $('.after-check-code').offset().top - 100
			        }, 500);
			      }
			    })

			})

			if (codeBox.val()) {
				codeBox.data('wasPrefilled', true);
				$('.check-code', t).click();
			}
		})
	}

}(jQuery)